import { Injectable } from '@angular/core'
import {
  PdpGalleryDialog,
  PdpGalleryDialogComponent
} from '../components/pdp-gallery-dialog/pdp-gallery-dialog.component'
import { GalleryImageData, MbVideoDatasetEntry } from '../../models'
import { MbModalService } from './modal.service'

@Injectable({
  providedIn: 'root'
})
export class PdpGalleryService {

  constructor (protected modalService: MbModalService) {
  }

  async openGalleryDialog (dialog: PdpGalleryDialog) {
    const { result, componentInstance } = this.modalService.open(PdpGalleryDialogComponent, {
      centered: true,
      scrollable: true,
      size: 'xl',
      modalDialogClass: 'mb-ng-modal',
      windowClass: 'pdp-gallery-ng-modal'
    })
    Object.keys(dialog).forEach(key => componentInstance[key] = dialog[key])
    return result
  }

  toActiveImageData<T extends MbVideoDatasetEntry> (item: T, legend: string) {
    return {
      image: item.url,
      legend,
      videoId: item.videoId,
      headline: item.headline
    }
  }

  toGalleryImageData<T extends MbVideoDatasetEntry> (items: T[],
                                                    legend: string) {
    return items.map(item => ({
      image: item?.url,
      legend,
      videoId: item.videoId,
      headline: item.headline
    }))
  }

  getThumbnail (videoId: string,
               thumbnails: GalleryImageData[]) {
    return thumbnails.find(thumbnail => thumbnail.videoId === videoId)
  }
}
